const theme = {
    colors: {
      background: "#0a192f",
      text: "#ccd6f6",
      primary: "#64ffda",
      secondary: "#8892b0",
    },
    fonts: {
      primary: "'Poppins', sans-serif",
    },
    breakpoints: {
      sm: "576px",
      md: "768px",
      lg: "992px",
      xl: "1200px",
    },
  };
  
  export default theme;